import { fetchTokenData } from "../../Common/axios_instance/axios_instance"


export const fetchTokenDataFun = async () => {
    try {
        let response = await fetchTokenData()
        console.log(response)
        return response.data
    } catch (error: any) {
        console.log(error)
        alert(error.response?.data?.message || "Some issue while getting token data")
    }

}
